import script from "./CreateModelsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateModelsView.vue?vue&type=script&setup=true&lang=ts"

import "./CreateModelsView.vue?vue&type=style&index=0&id=2ca7987e&lang=scss"

const __exports__ = script;

export default __exports__